var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.95329H2.5M13.3333 2.28662V5.61995M6.66667 2.28662V5.61995M6.5 18.9533H13.5C14.9001 18.9533 15.6002 18.9533 16.135 18.6808C16.6054 18.4411 16.9878 18.0587 17.2275 17.5883C17.5 17.0535 17.5 16.3534 17.5 14.9533V7.95329C17.5 6.55316 17.5 5.85309 17.2275 5.31831C16.9878 4.84791 16.6054 4.46545 16.135 4.22577C15.6002 3.95329 14.9001 3.95329 13.5 3.95329H6.5C5.09987 3.95329 4.3998 3.95329 3.86502 4.22577C3.39462 4.46545 3.01217 4.84791 2.77248 5.31831C2.5 5.85309 2.5 6.55316 2.5 7.95329V14.9533C2.5 16.3534 2.5 17.0535 2.77248 17.5883C3.01217 18.0587 3.39462 18.4411 3.86502 18.6808C4.3998 18.9533 5.09987 18.9533 6.5 18.9533Z",
    stroke: "#B1B6BF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.098b90f50f14642bd5512cd72b33c28a.svg";
export { ForwardRef as ReactComponent };